<script setup lang="ts">
defineComponent({
    name: "PrecompiledField",
});

const props = defineProps({
    label: {
        type: String,
        required: true
    },
});

const value = defineModel<string | number | null>();

</script>

<template>
    <div class="precompiled-field w-full">
        <p class="text-gray-3 text-sm font-semibold leading-none pointer-events-none">{{ props.label }}</p>
        <input type="text" disabled v-model="value" class="text-base mt-1 pointer-events-none bg-none w-full uppercase" />
    </div>
</template>